/* eslint-disable camelcase */
import React, { FC } from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import { Luci_Shopping_Api_Responses_GetStoreCustomerRewardsByGuidResponse } from '../../types/api/v7.1/models/Luci_Shopping_Api_Responses_GetStoreCustomerRewardsByGuidResponse';
import Styles from '../../pages/InvoicePortalConfirmation/InvoicePortalConfirmation.module.scss';

const RewardsPanel: FC<
  Luci_Shopping_Api_Responses_GetStoreCustomerRewardsByGuidResponse & {
    totalPointsAccruedOnThisOrder: number;
  }
> = ({
  totalPointsAccruedOnThisOrder,
  pointsAvailable,
  rewardsAvailable,
  rewardPointGoal,
  pointsNeededForNextReward,
}) => {
  const theme = useTheme();

  // Helper function to handle pluralization
  function isPlural(quantity: number, text: string): string {
    return quantity !== 1 ? `${text}s` : text;
  }

  function customerPointsAvailable(): boolean {
    return pointsAvailable !== undefined && pointsAvailable > 0;
  }

  return (
    <Grid
      item
      xs={12}
      paddingTop="1rem"
      sx={{ borderTop: `1px solid ${theme.palette.divider}` }}
    >
      <Typography component="h3" variant="h4" marginBottom=".5rem">
        <strong>Rewards</strong>
      </Typography>
      <section
        className={Styles.rewards}
        data-testid="rewards-section"
        style={{
          background: theme.palette.secondary.main,
          marginBottom: '1rem',
        }}
      >
        <div className={Styles.rewardsBody}>
          <Typography
            data-testid="points-earned"
            className={`${Styles.rewardsHighlight} ${Styles.rewardsLargeText}`}
            style={{ color: 'rgba(236, 0, 140, 1)' }}
          >
            You have earned {totalPointsAccruedOnThisOrder}{' '}
            {isPlural(totalPointsAccruedOnThisOrder, 'point')} on this order
          </Typography>
          {customerPointsAvailable() && (
            <Typography>
              You now have{' '}
              <span className={Styles.bold}> {rewardsAvailable} </span>{' '}
              {isPlural(rewardsAvailable ?? 0, 'reward')} available!
            </Typography>
          )}
        </div>
      </section>
      <Typography data-testid="rewards-goal">
        <b>
          Buy {rewardPointGoal ?? '?'} {isPlural(rewardPointGoal ?? 1, 'item')}{' '}
          and get 1 FREE.
        </b>
        <br />
        You have earned <b>{totalPointsAccruedOnThisOrder}</b>{' '}
        {isPlural(totalPointsAccruedOnThisOrder, 'point')} on this order.
      </Typography>
      {pointsNeededForNextReward && (
        <Typography data-testid="points-needed" marginBottom="1rem">
          You need{' '}
          <span className={Styles.bold}>{pointsNeededForNextReward}</span>{' '}
          more {isPlural(pointsNeededForNextReward, 'point')} to earn a free
          item.
        </Typography>
      )}
      {/* {customerRewardsURL && (
        <p>
          <a className={Styles.bold} href={customerRewardsURL}>
            View my rewards
          </a>
        </p>
      )} */}
    </Grid>
  );
};

export default RewardsPanel;
